<script>
  export let title, distance, length, id, image, summary, description
</script>

<h6>{title}</h6>
<div class="meta-data">
  <svg style="margin-right:5px; margin-top: 4px;" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M4.16675 7.49999C4.16675 4.27499 6.77508 1.66666 10.0001 1.66666C13.2251 1.66666 15.8334 4.27499 15.8334 7.49999C15.8334 11.875 10.0001 18.3333 10.0001 18.3333C10.0001 18.3333 4.16675 11.875 4.16675 7.49999ZM7.91675 7.49999C7.91675 8.64999 8.85008 9.58332 10.0001 9.58332C11.1501 9.58332 12.0834 8.64999 12.0834 7.49999C12.0834 6.34999 11.1501 5.41666 10.0001 5.41666C8.85008 5.41666 7.91675 6.34999 7.91675 7.49999Z"
      fill="#202020" />
  </svg>
  <p class="caption">Buxton Station</p>
  <svg style="margin-top:6px; margin-left:20px; margin-right: 6px;;" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M8.325 0C3.725 0 0 3.73333 0 8.33333C0 12.9333 3.725 16.6667 8.325 16.6667C12.9333 16.6667 16.6667 12.9333 16.6667 8.33333C16.6667 3.73333 12.9333 0 8.325 0ZM8.33341 15C4.65008 15 1.66675 12.0167 1.66675 8.33333C1.66675 4.65 4.65008 1.66666 8.33341 1.66666C12.0167 1.66666 15.0001 4.65 15.0001 8.33333C15.0001 12.0167 12.0167 15 8.33341 15ZM7.5 4.16666H8.75V8.54166L12.5 10.7667L11.875 11.7917L7.5 9.16666V4.16666Z"
      fill="#202020" />
  </svg>
  <p class="caption">{length} mins</p>
</div>

<style>
  h6 {
    margin: 0;
  }

  .meta-data {
    display: flex;
  }

  p {
    margin-top: 6px;
  }
</style>
